import { useMemo, useState } from 'react';
import {
  ChartDownloadMetricList,
  ChartDownloadMetricListMobile,
  ChartDownloadMetricListSteam,
  ChartDownloadMetricListNewzoo,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { isEmpty } from '@/pages/intelligence/utils/commonUtils';

// 游戏详情统一可视化下载，卡片配置对象内容
export default function useChartDownloadHooks(props: any) {
  const {
    locale,
    metricValue,
    source = '',
    dateType = '',
    entityType = '',
    activeSegment = '',
    isStreamingPage = false,
  } = props;
  // console.log('useChartDownloadHooks', props);

  const [sumList, setSumList] = useState<any>([]);
  const [trendsChartDownList, setTrendsChartDownList] = useState<any>([]);

  const hasData = useMemo(() => {
    return trendsChartDownList?.length > 0;
  }, [trendsChartDownList]);

  const dateTypeText = useMemo(() => {
    switch (dateType) {
      case 'monthly':
      case 'month':
        return 'MAU';
      case 'weekly':
      case 'week':
        return 'WAU';
      case 'daily':
      case 'day':
      default:
        return 'DAU';
    }
  }, [dateType]);

  const notMetricValue = useMemo(() => {
    // console.log('activeSegment~~~~~~~~~~~~!!!!!!', activeSegment);
    switch (activeSegment) {
      case 'steamfollowers':
      case 'steamreviews':
        return true;
      default:
        return false;
    }
  }, [entityType, activeSegment, metricValue]);

  const chartDownloadConfig = useMemo(() => {
    const isCN = locale !== "en-US";
    const metricValueCur = (entityType === 'combine' && activeSegment === 'acu') ? activeSegment : metricValue;
    const metricListTemp = entityType === 'mobile' ? ChartDownloadMetricListMobile : ChartDownloadMetricList;
    const metricObj = metricListTemp?.find((item: any) => item.metricKey == metricValueCur) || {} as any;
    const sumListObj: any = Array.isArray(sumList) ? (sumList?.find((item: any) => item.date == 'sum') || {}) : {};
    const sumListTemp = isStreamingPage ? sumList : sumListObj?.metrics || [];
    if (isEmpty(metricObj) || notMetricValue) {
      return {
        title: '',
        sourceIcon: '',
        sumValue: [],
        isNoData: true,
      }
    } else {
      return {
        title: isCN ? metricObj.textCN : metricObj.text + (metricValueCur === 'activeusers' ? '(' + dateTypeText + ')' : ''),
        sourceIcon: source !== '' ? source : metricObj.iconkey,
        sumValue: sumListTemp,
        isNoData: !hasData,
      };
    }
  }, [locale, sumList, metricValue, hasData, notMetricValue]);

  const showDropdownBtnListSteamCur = useMemo(() => {
    const metricList = [...ChartDownloadMetricList, ...ChartDownloadMetricListSteam, ...ChartDownloadMetricListNewzoo];
    const metricValueCur = (entityType === 'combine' && activeSegment === 'acu') ? activeSegment : metricValue;
    const metricObj = metricList?.find((item: any) => item.metricKey == metricValueCur) || {} as any;
    if (notMetricValue) {
      return false;
    } else {
      return !isEmpty(metricObj);
    }
  }, [metricValue, entityType, notMetricValue]);

  // console.log('showDropdownBtnListSteamCur',showDropdownBtnListSteamCur);

  return {
    chartDownloadConfig,
    setSumList,
    showDropdownBtnListCur: showDropdownBtnListSteamCur,
    setTrendsChartDownList,
  };
}
